import { IScheduleDTO } from '../shared/interfaces/schedule-interfaces';
import { daysOfWeek, IDaysOfWeek } from './constants';

const parseDaysOfWeek = (schedule: IScheduleDTO): string => {
  return Object.keys(daysOfWeek)
    .filter(day => schedule[day as keyof IScheduleDTO])
    .map(day => daysOfWeek[day as keyof IDaysOfWeek])
    .join(', ');
};

export { parseDaysOfWeek };
